<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text"><span v-if="user.loginEmail">{{ user.loginEmail }} orders</span></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="white--text">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      :width=500
    >
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            text-xs-center
            layout
            align-center
            justify-center
            class="pl-4 pr-4"
          >
            <v-form ref="form" v-model="frmValid" lazy-validation>
              <v-menu
                ref="dtMinOrderDate"
                :close-on-content-click="false"
                v-model="dtMinOrderDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="txtMinOrderDate"
                  label="Min Order Date"
                ></v-text-field>
                <v-date-picker v-model="txtMinOrderDate" no-title @input="dtMinOrderDate = false"></v-date-picker>
              </v-menu>
              <v-menu
                ref="dtMaxOrderDate"
                :close-on-content-click="false"
                v-model="dtMaxOrderDate"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="txtMaxOrderDate"
                  label="Max Order Date"
                ></v-text-field>
                <v-date-picker v-model="txtMaxOrderDate" no-title @input="dtMaxOrderDate = false"></v-date-picker>
              </v-menu>
              <v-select
                v-model="cboCourierId"
                :items="couriers"
                item-text="courierName"
                item-value="courierId"
                label="Courier"
              ></v-select>
              <v-select
                v-model="cboPaymentMethodId"
                :items="paymentMethods"
                item-text="paymentMethodName"
                item-value="paymentMethodId"
                label="Payment Method"
              ></v-select>
              <v-select
                v-model="cboSort"
                :items="sorts"
                item-text="title"
                item-value="key"
                label="Sorting"
              ></v-select>
              <v-btn
                @click="items=[]; getSalesOrders(txtName, txtMinOrderDate, txtMaxOrderDate, cboCourierId, cboPaymentMethodId, cboSort); rightDrawer=false;"
              >
                Filter
              </v-btn>
              <v-btn @click="clearFilter">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-tabs
        color="grey darken-4"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          v-for="(item, index) in tabs"
          :key="index"
          @click="items=[]"
          :to="'/customer/' + userId + '/orders/' + item.key"
        >
          {{ item.title }}
        </v-tab>
      </v-tabs>
      <v-list
        two-line
      >
        <template
          v-for="(item, index) in items"
        >
          <v-list-tile
            :key="item.salesOrderNo"
            avatar
            ripple
            :class="(index % 2 === 0 ? 'row1' : 'row2')"
          >
            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-icon v-if="item.deliveryStatus === 'sent'" medium color="green darken-2">check_circle_outline</v-icon>
                <v-icon v-else-if="item.paymentStatus === 'paid' || item.paymentStatus === 'credit'" medium color="orange lighten-2">play_circle_outline</v-icon>
                <v-icon v-else-if="item.paymentStatus !== 'none'" medium color="white darken-1">hourglass_empty</v-icon>
                <v-icon v-else medium color="grey darken-1">hourglass_empty</v-icon>
              </v-list-tile-action-text>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                <router-link class="font-weight-bold orange--text text--lighten-2" :to="'/order/' + item.salesOrderNo">{{ item.salesOrderNo }}</router-link>
                <span v-if="item.invoiceNo" class="caption ml-3">({{ item.invoiceNo }})</span>
                <span v-if="item.paymentStatus === 'chargeback'" class="body-1 ml-3 font-weight-bold red--text">CHARGEBACK</span>
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{ item.shippingEmail }} - {{ item.paymentMethodName }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{ item.shippingCityName }}, {{ item.shippingProvinceName }}, {{ item.shippingCountryName }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text v-if="item.paidDateTime">{{ item.paidDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</v-list-tile-action-text>
              <v-list-tile-action-text v-else>{{ item.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</v-list-tile-action-text>
              <strong>{{ item.currencySign }}{{ formatPrice(item.cacheTotalSales + item.deliveryCost + item.importTariff, item.currencyDecimals, item.currencyDecimalSign) }}</strong>
            </v-list-tile-action>

            <v-btn icon class="ml-3" color="primary" :to="'/order/' + item.salesOrderNo">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No sales yet
            </div>
          </v-flex>
        </template>
      </v-list>

      <v-container fluid grid-list-xs class="mt-3 mb-0">
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <div class="mb-3">
              Showing {{ listCountFrom }} - {{ listCountTo }} of {{ listTotal }} orders
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-sm-and-up">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="5"
              circle
            ></v-pagination>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-xs-only">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="12"
              circle
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-container>

      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>

    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'

export default {
  props: [
    'userId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      rightDrawer: false,
      loading: false,
      user: {},
      frmValid: true,
      txtName: '',
      dtMinOrderDate: false,
      dtMaxOrderDate: false,
      txtMinOrderDate: '',
      txtMaxOrderDate: '',
      cboCourierId: null,
      couriers: [],
      cboPaymentMethodId: '',
      paymentMethods: [],
      cboType: '',
      types: ['retail', 'wholesale'],
      cboSort: 'desc',
      sorts: [
        {
          key: 'desc',
          title: 'Latest'
        },
        {
          key: 'asc',
          title: 'From beginning'
        }
      ],
      currency: {
        currencyCode: 'IDR',
        sign: 'Rp',
        decimalSign: ',',
        thousandSeparator: '.',
        exchangeRateToBase: 1
      },
      items: [],
      listLimit: 15,
      listOffset: 0,
      listTotal: 0,
      listCountFrom: 0,
      listCountTo: this.listLimit,
      pageNo: parseInt(this.$route.query.pg) || 1,
      pageCount: 0,
      tabs: [
        {
          key: '',
          title: 'All'
        },
        {
          key: 'pending',
          title: 'Pending'
        },
        {
          key: 'in-progress',
          title: 'In-progress'
        },
        {
          key: 'shipped',
          title: 'Shipped'
        },
        {
          key: 'unpaid',
          title: 'Unpaid'
        }
      ]
    }
  },
  mounted () {
    this.openDrawerForDesktop()
    this.getSalesOrders(this.txtName, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboPaymentMethodId, this.cboSort)
    this.getCustomer()
    this.listCouriers()
    this.listPaymentMethods()
  },
  created () {
    // window.addEventListener('scroll', this.detectBottomOfWindow)
  },
  destroyed () {
    // window.removeEventListener('scroll', this.detectBottomOfWindow)
  },
  watch: {
    pageNo (val, oldVal) {
      // If page no changes, navigate to new page
      this.getSalesOrders(this.txtName, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboPaymentMethodId, this.cboSort, (val - 1) * this.listLimit)
    },
    $route (to, from) {
      // If url changes, refresh list
      this.getSalesOrders(this.txtName, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboPaymentMethodId, this.cboSort)
    }
  },

  methods: {
    detectBottomOfWindow: function () {
      window.onscroll = () => {
        // console.log(document.documentElement.scrollTop + window.innerHeight) - 48
        // console.log(document.documentElement.offsetHeight)
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight

        if (bottomOfWindow) {
          if (this.listTotal > this.items.length) {
            this.getSalesOrders(this.txtName, this.txtMinOrderDate, this.txtMaxOrderDate, this.cboCourierId, this.cboPaymentMethodId, this.cboSort, this.items.length)
          }
        }
      }
    },
    listCouriers: function () {
      var url = process.env.VUE_APP_API_ROOT + '/v1/shipping/couriers/CHN'
      var _this = this
      axios.get(url)
        .then(resp => {
          if (resp.data.status === 'success') {
            _this.couriers = [{
              courierId: '',
              courierName: '-'
            }]
            _this.couriers = _this.couriers.concat(resp.data.data)
          } else {
            console.log('unable to list couriers: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    listPaymentMethods: function () {
      var url = process.env.VUE_APP_API_ROOT + '/v1/payment/methods'
      var _this = this
      axios.get(url)
        .then(resp => {
          if (resp.data.status === 'success') {
            _this.paymentMethods = [{
              paymentMethodId: '',
              paymentMethodName: '-'
            }]
            _this.paymentMethods = _this.paymentMethods.concat(resp.data.data)
          } else {
            console.log('unable to list payment methods: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getCustomer: function () {
      this.loading = true
      let _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/' + this.userId)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.user = resp.data.data
          } else {
            console.log('unable to load user details: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getSalesOrders: function (shippingName = '', minCreatedDate = '', maxCreatedDate = '', courierId = '', paymentMethodId = '', sort = 'desc', offset = 0) {
      var key = this.$route.params.key
      var apiParam = 'user_id=' + this.userId

      switch (key) {
        case 'pending':
          apiParam += '&payment_status=pending,in-verification'
          break
        case 'in-progress':
          apiParam += '&payment_status=paid,credit&delivery_status=pending,partial'
          break
        case 'shipped':
          apiParam += '&delivery_status=sent,delivered'
          break
        case 'unpaid':
          apiParam += '&payment_status=none,partial'
          break
        default:
          break
      }

      if (courierId === null) {
        courierId = ''
      }

      apiParam += '&shippingName=' + shippingName + '&courier_id=' + courierId + '&min_created_date=' + minCreatedDate + '&max_created_date=' + maxCreatedDate + '&payment_method_id=' + paymentMethodId + '&sort=createdDateTime%3A' + sort + '&limit=' + this.listLimit + '&offset=' + offset
      this.loading = true
      let _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales?' + apiParam)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            for (var i in resp.data.data) {
              // inject displayDateTime
              if (resp.data.data[i].paymentStatus === 'paid' || resp.data.data[i].paymentStatus === 'credit') {
                resp.data.data[i].displayDateTime = resp.data.data[i].paidDateTime
              } else {
                resp.data.data[i].displayDateTime = resp.data.data[i].createdDateTime
              }

              // inject payment method names
              if (resp.data.data[i].paymentStatus !== 'none') {
                let methodNamesObject = {}
                let methodNames = ''
                for (var j in resp.data.data[i].payments) {
                  // filter distinct methods only
                  if (typeof methodNamesObject[resp.data.data[i].payments[j].paymentMethodName] === 'undefined') {
                    methodNamesObject[resp.data.data[i].payments[j].paymentMethodName] = resp.data.data[i].payments[j].paymentMethodName
                    if (methodNames !== '') {
                      methodNames = methodNames + ', '
                    }
                    methodNames = methodNames + resp.data.data[i].payments[j].paymentMethodName
                  }
                }
                resp.data.data[i].paymentMethodName = methodNames
              }
            }
            _this.items = resp.data.data
            _this.listLimit = resp.data.limit
            _this.listOffset = resp.data.offset
            _this.listTotal = resp.data.total
            _this.pageCount = Math.ceil(_this.listTotal / _this.listLimit)
            _this.listCountFrom = _this.listOffset + 1
            _this.listCountTo = (_this.listCountFrom - 1) + _this.items.length
            if (_this.items.length === 0) {
              _this.listCountFrom = 0
              _this.listCountTo = 0
            }
          } else {
            console.log('unable to load sales order list: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    clearFilter () {
      this.txtName = ''
      this.txtMinOrderDate = ''
      this.txtMaxOrderDate = ''
      this.cboCourierId = null
      this.cboPaymentMethodId = null
      this.cboSort = null
      this.items = []
      this.listOffset = 0
      this.listTotal = 0
      this.pageCount = 1
      this.listCountFrom = 0
      this.listCountTo = 0
      this.pageNo = 1
      this.rightDrawer = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
